import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vt9rkhen92: FaireBrandEntity = {
  token: "b_vt9rkhen92",
  type: "brand",
  name: "Dandelion Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc18a5bf5ff6284176bfae24baf75034c5122e7f826dc5614d9f24281ab68f2d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6c47c4492aadc397c686cec7ef45e79df67111ad8809e913aa1cc909eb61a470.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fc18a5bf5ff6284176bfae24baf75034c5122e7f826dc5614d9f24281ab68f2d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6c47c4492aadc397c686cec7ef45e79df67111ad8809e913aa1cc909eb61a470.jpeg",
  location: "Hayfield, MN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 78,
  isTopShop: true,
  isInsider: true,
  description:
    "Dandelion Naturals began in our kitchen on the Hamilton homestead in southeast Minnesota in 2022 — where bright yellow dandelions bloom wild each spring, symbolizing renewal, strength, and the return of life after a long winter.\n\nFounded by Michelle, a retired nurse of 21 years, Dandelion Naturals was born from a deep understanding of how to care for the body with gentleness, purpose, and intention. Her experience in nursing laid the foundation for this new path — one focused on healing, nurturing, and protecting the skin using simple, earth-based ingredients.\n\nWhat began as a small-batch soap making project on the homestead has blossomed into a growing product line for the body + home + gifting, now made in our commercial studio by a team of 5 women and is sold at our flagship brick-and-mortar store. We are also honored to have our products carried by a growing number of retailers across the country — a reflection of the care, quality, and intention behind every batch.\n\nTo us, the dandelion is more than a flower — it’s a symbol of resilience, hope, and healing. It reminds Michelle of the season her daughter was born and of nature’s power to regenerate and thrive.\n\nDandelion Naturals is a sweet reminder of the bounty of the earth, the strength of nature, and the love we can show our skin through thoughtful, handcrafted care.\n\nXO, Michelle and the Dande Crew",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:37.463Z",
    importedBy: "entity-db-cli",
  },
};
